"use client";

import { Link } from "@/components/common/Link";
import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
function WhatsAppButton() {
  return <div className="fixed bottom-6 right-6 z-[9999]">
      <Link to="https://wa.me/905326599193?text=Merhaba%2C%20hukuki%20destek%20almak%20istiyorum." newTab aria-label="WhatsApp ile iletişime geç" className="block">
        <Button className="h-12 px-6 bg-[#25D366] hover:bg-[#20ba5a] text-white rounded-lg shadow-lg transition-transform duration-300 hover:scale-105 flex items-center gap-2 border-none font-medium">
          <MessageCircle className="w-5 h-5" />
          <span>Avukata Danış</span>
        </Button>
      </Link>
    </div>;
}
export default function Footer() {
  return <>
      <section data-section-id="3038" id="footer" className="bg-[#0B1420] border-t border-border py-6 mt-12">
        <div className="max-w-7xl mx-auto px-6 flex flex-col items-center text-center space-y-3">
          {}
          <p className="font-default text-sm font-medium tracking-wide text-[#D9D9D9]">
            © 2026 Av. Arda Can Şahin
          </p>

          {}
          <address className="not-italic font-default text-sm text-[#FFFFFF]">
            Route İstanbul Plaza B Blok D:144 Ataköy 7-8-9-10. Kısım Mah. Çobançeşme E-5 Yanyol Cd. Bakırköy/İSTANBUL
          </address>

          {}
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-6 font-default text-sm">
            <Link to="tel:+905326599193" className="text-[#FFFFFF] hover:text-[#C9A15A] transition-colors duration-300">
              +90 532 659 91 93
            </Link>
            <Link to="mailto:avukat@ardacansahin.av.tr" className="text-[#FFFFFF] hover:text-[#C9A15A] transition-colors duration-300">
              avukat@ardacansahin.av.tr
            </Link>
          </div>
        </div>
      </section>
      <WhatsAppButton />
    </>;
}